import 'devextreme/dist/css/dx.common.css';
//import './themes/generated/theme.base.css';
import 'devextreme/dist/css/dx.light.compact.css';
import './themes/generated/theme.additional.css';
import React, { useEffect, useState } from 'react';
import { HashRouter as Router } from 'react-router-dom';
import './dx-styles.scss';

import { LoadPanel } from 'devextreme-react/load-panel';
import { NavigationProvider } from './contexts/navigation';
// import {LanguageProvider, useLanguage} from './contexts/language';
import { useScreenSizeClass } from './utils/media-query';
import Content from './Content';
import NotAuthenticatedContent from './NotAuthenticatedContent';
import { useDispatch, useSelector } from "react-redux";
//import * as languageActions from './actions/languageActions';
import * as authActions from './actions/authActions';
//import * as langUtils from './utils/languageConversationUtils.js';


function App() {
    // const {language, getTranslations} = useLanguage();
    const auth = useSelector(state => state.auth);
    const language = useSelector(state => state.language);
    const localLanguage = JSON.parse(localStorage.getItem('language'));

    const dispatch = useDispatch();
    // debugger;
    if (language != null && localLanguage != null) {
        if (language.code !== localLanguage.code) {
            //dispatch(languageActions.getTranslations());
        }
    }

    //const [locale, setLocale] = useState(initLocale)


    useEffect(() => {
        if (auth != null && auth.user != null && auth.user.loggedIn) {
            // dispatch(langUtils.initLocalization());
            // dispatch(languageActions.getList());
            // dispatch(languageActions.getTranslations());
        }

        // langUtils.setLocale(language);          
    }, [])

    useEffect(() => {
        if (auth != null && auth.user != null && auth.user.loggedIn) {
            // dispatch(langUtils.initLocalization());
            // dispatch(languageActions.getList());
            // dispatch(languageActions.getTranslations());
        }
        // langUtils.setLocale(language);          
    }, [auth])

    // langUtils.setLocale(language);

    //

    useEffect(() => {
        //console.log("dil"); 

        // langUtils.setLocale(language);

        //dispatch(languageActions.getTranslations());
        //locale = "tr"
        //dispatch(localeActions.getLocaleSuccess("ru"));

        //document.location.reload()
        //let a = language.code
    }, [language])




    // initMessages() {
    //     loadMessages(deMessages);
    //     loadMessages(ruMessages);
    //     //loadMessages(service.getDictionary());
    //   }

    //   changeLocale(e) {
    //     this.setState({
    //       locale: e.value
    //     });
    //     this.setLocale(e.value);
    //     document.location.reload();
    //   }

    // if (loading) {
    //     return <LoadPanel visible={true}/>;
    // }
    if (auth.user.loggedIn) {
        return <Content />;
    } else {
        const jwtDecode = require('jwt-decode');
        let token = localStorage.getItem('token');
        if (token != null && token !== "") {
            let decoded = jwtDecode(token);
            if (decoded != null && decoded.exp != null && Date.now() < decoded.exp * 1000) {
                dispatch(authActions.loginSuccess({
                    loggedIn: true,
                    username: decoded.username,
                    name: decoded.name
                }));
                return <Content />;
            }
        }
    }


    return <NotAuthenticatedContent />;
}

export default function () {
    const screenSizeClass = useScreenSizeClass();
    const {loadingData}  = useSelector(state => state.appReducer);

    return (
        <div style={{ height: '100%' }}>
            <div id="appmaindiv" style={{ height: '100%' }}>
                <div className={`app ${screenSizeClass}`}>
                    <Router>
                        <NavigationProvider  >

                            <App />

                        </NavigationProvider>
                    </Router>
                </div>
            </div>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                id="load"
                position={{ of: '#appmaindiv' }}
                //onHiding={this.hideLoadPanel}
                message={loadingData.text}
                visible={loadingData.visible}
                showIndicator={true}
                shading={true}
                showPane={true}
                closeOnOutsideClick={true}
            />
        </div>
    );
}
